<div class="chart-legend">
  <div
    class="is-flex is-align-items-flex-start is-justify-content-center is-flex-wrap-wrap mt-4"
  >
    <div
      *ngFor="let value of possibleValues"
      class="is-flex is-align-items-center is-justify-content-flex-start mr-4 mb-2"
    >
      <div class="group-item mr-2" [style.background-color]="value.color"></div>
      <span class="content is-small">{{ value.label }}</span>
    </div>
  </div>
</div>

<canvas
  baseChart
  [data]="barChartData"
  [options]="barChartOptions"
  [legend]="false"
  type="bar"
  *ngIf="barChartData"
  (chartClick)="onChartClick($event)"
>
</canvas>
